import React from "react";
import { Outlet } from "react-router-dom";
import SideNav from "./components/SideNav";

function Layout() {
  return (
    <>
      <div className="d-flex">
        <div>
          <SideNav />
        </div>
        <div className="container gap-3">
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default Layout;
